"use client";

import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
function ExperiencesConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[600px] rounded-2xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground">
        Failed to load experiences.
      </div>;
  }
  if (products.length === 0) {
    return <p className="text-center text-muted-foreground">No experiences available.</p>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <article key={product.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-2xl bg-white shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:shadow-strong">
          {}
          <div className="relative h-[180px] overflow-hidden bg-gradient-to-br from-primary/20 to-accent/20 transition-all duration-[var(--duration-slow)] group-hover:h-[220px]">
            {product.featured_image_url && <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-slow)] group-hover:scale-110" loading="lazy" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="font-display text-2xl font-bold text-white leading-tight">
                {product.title}
              </h3>
            </div>
          </div>

          {}
          <div className="flex flex-1 flex-col justify-between p-6 transition-all duration-[var(--duration-slow)] group-hover:pt-8">
            <div className="space-y-4">
              {product.short_description && <p className="text-sm leading-relaxed text-muted line-clamp-4">
                  {product.short_description}
                </p>}
              
              {product.price !== undefined && <div className="flex items-baseline gap-2">
                  <span className="text-3xl font-bold text-primary">
                    ${product.price}
                  </span>
                  {product.discounted_price !== undefined && product.discounted_price < product.price && <span className="text-lg text-muted line-through">
                      ${product.discounted_price}
                    </span>}
                  <span className="text-sm text-muted-foreground">per person</span>
                </div>}
            </div>

            <div className="mt-6 space-y-3">
              <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="bg-primary text-foreground-primary" text="Book Now" showQuantity={false} />
              
              <Link to={product.link || "#"}>
                <Button variant="ghost" className="w-full group/btn transition-all duration-[var(--duration-fast)] hover:bg-secondary/10 hover:scale-[1.03] hover:text-secondary">
                  Learn More
                  <ChevronRight className="ml-1 size-4 transition-transform group-hover/btn:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function OurExperiences() {
  return <section id="our-experiences" className="dark bg-background text-foreground py-24 px-4">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Our Experiences
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted">
            Discover exclusive eco-luxury adventures in the heart of Riviera Maya
          </p>
        </div>

        <EcommerceProductsProvider postType="product" wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }} fields={["id", "title.rendered", "short_description", "price", "discounted_price", "featured_image_url", "link"]} className="w-full">
          <ExperiencesConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}